import {RouteRecordRaw} from "vue-router";
import {EUserRole} from "@/app/shared/state/user-role";
import {klipIndex} from "@/router/klip-index";
import {useUserStore} from "@/app/shared/state/UserDataModule";

const checkEnforcerRegistration: RouteRecordRaw['beforeEnter'] = (to, from, next) => {
    const userStore = useUserStore();

    if (userStore.user?.isEnforcerFirstLogin) {
        next({ name: 'enforcer-not-registered' });
    } else {
        next();
    }
};

export const EnforcerIndex: RouteRecordRaw = {
    path: '/enforcer',
    name: 'enforcer',
    component: () => import('./index.vue'),
    meta: {
        authorize: { roles: [EUserRole.enforcer] },
        breadcrumb: { title: '', parent: klipIndex },
    },
    beforeEnter: checkEnforcerRegistration,
};

export const EnforcerNotRegistered: RouteRecordRaw = {
    path: '/enforcer/not-registered',
    name: 'enforcer-not-registered',
    component: () => import('./not-registered.vue'),
    meta: {
        authorize: { roles: [EUserRole.enforcer] },
        breadcrumb: { title: '', parent: klipIndex },
    },
};

export const EnforcerMapRequestDetail: RouteRecordRaw = {
    path: '/enforcer/maprequest/:id',
    name: 'enforcerMapRequestDetail',
    component: () => import('./maprequest/map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.enforcer] },
        breadcrumb: { title: 'Planaanvraag', parent: EnforcerIndex },

    },
    beforeEnter: checkEnforcerRegistration,
};

export const EnforcerViewer: RouteRecordRaw = {
    path: '/enforcer/viewer/:id',
    name: 'enforcerviewer',
    component: () => import('./../viewer/index.vue'),
    meta: {
        authorize: { roles: [EUserRole.enforcer] },
        breadcrumb: {
            title: 'Leidingviewer',
            parent: EnforcerIndex // mriViewer is opened on a separate tab = we do not need a mriMapRequest as parent
        },
    },
};

export const EnforcerArchivedMapRequestDetail: RouteRecordRaw = {
    path: '/enforcer/maprequest/:id/archived',
    name: 'enforcerArchivedMriDetail',
    component: () => import('./maprequest/archived-map-request.vue'),
    meta: {
        authorize: { roles: [EUserRole.enforcer] },
        breadcrumb: { title: 'Planaanvraag', parent: EnforcerIndex },
    },
    beforeEnter: checkEnforcerRegistration,
};

export default [
    EnforcerIndex,
    EnforcerNotRegistered,
    EnforcerMapRequestDetail,
    EnforcerArchivedMapRequestDetail,
    EnforcerViewer,
];